import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  update(e) {
    history.pushState(null, null, this.urlValue)
  }
}
